import { render, staticRenderFns } from "./v-upload-logo.vue?vue&type=template&id=ca0fd9c6&"
import script from "./v-upload-logo.vue?vue&type=script&lang=js&"
export * from "./v-upload-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports